import React from 'react';

interface Product {
  name: string;
  allocation: string;
  category: string;
  riskLevel: string;
  description: string;
  expectedReturn: string;
}

interface RecommendationCardProps {
  product: Product;
}

const RecommendationCard: React.FC<RecommendationCardProps> = ({ product }) => {
  const getRiskColor = (riskLevel: string) => {
    switch (riskLevel.toLowerCase()) {
      case 'très faible':
        return 'bg-green-100 text-green-800';
      case 'faible':
        return 'bg-blue-100 text-blue-800';
      case 'modéré':
        return 'bg-yellow-100 text-yellow-800';
      case 'élevé':
        return 'bg-orange-100 text-orange-800';
      case 'très élevé':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <h4 className="text-lg font-semibold text-gray-800">{product.name}</h4>
        <span className="text-sm font-medium text-green-600">{product.allocation}</span>
      </div>
      
      <div className="mb-2">
        <span className="text-sm font-medium text-gray-600">{product.category}</span>
      </div>
      
      <p className="text-gray-700 text-sm mb-3">{product.description}</p>
      
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-gray-600">Risque:</span>
          <span className={`text-xs px-2 py-1 rounded-full ${getRiskColor(product.riskLevel)}`}>
            {product.riskLevel}
          </span>
        </div>
        
        <div className="text-sm font-medium text-gray-800">
          {product.expectedReturn}
        </div>
      </div>
    </div>
  );
};

export default RecommendationCard;